import type { Session } from './session';
import type { CoachProfile, User } from './user';

export enum NoteOwnerType {
  SESSION = 'Session',
  USER = 'User',
  COACH_PROFILE = 'CoachProfile',
}

export interface Note {
  author: User;
  authorId: string;
  createdAt: Date;
  id: string;
  owneableId: string;
  owneableType: NoteOwnerType;
  owner: User | Session | CoachProfile;
  updatedAt: Date;
  value: string;
  // TODO: add teams stuff once done in BE
}
